// extracted by mini-css-extract-plugin
export default {"base":"DashboardPage_base__IhUGM","mapPanel":"DashboardPage_mapPanel__FWhOw","tablePanel":"DashboardPage_tablePanel__mdRWV"};